import { ResourceHistoryPanel } from './ResourceHistoryPanel.component'
import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'

const withUnmountHoc = withUnmountTransition(ResourceHistoryPanel)
export { withUnmountHoc as ResourceHistoryPanel }
